module.exports = __webpack_public_path__ + "static/scale-model-of-idlewild-butterfly-farm-in-louisville-kentucky-c0a2da3ef5c5a9027999ac177ec387b7.png";